import type { ExclusionAreaUnresolvedCount } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export const getUnresolvedCountByFarm = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<ExclusionAreaUnresolvedCount[]> => {
  const response = await apiClient.get(
    endpoints.v2.farms.exclusionAreaObservationsUnresolvedCount(farmId),
    { signal },
  )
  return unwrapCollection<ExclusionAreaUnresolvedCount>(response)
}
